<div class="photographer-list container">
  @if (initialLoading) {
    @for (_ of [0, 1, 2, 3, 4, 5, 6, 7]; track _) {
      <app-photographer-list-item [photographer]="null"></app-photographer-list-item>
    }
  }
  @if (!initialLoading) {
    @for (photographer of photographers; track photographer; let i = $index) {
      <a
        [href]="'/photographer/' + photographer.slug"
        target="_blank"
        rel="noopener"
        class="photographer-list-link"
        (click)="onCardClick(photographer.id, i + 1)"
      >
        <app-photographer-list-item [photographer]="photographer"></app-photographer-list-item>
      </a>
    }
  }
</div>

@if (photographers.length === 0 && !initialLoading) {
  <div class="empty-state">
    <i class="fa-solid fa-camera-retro"></i>
    <h2>{{ 'marketplace.search.empty-state.title' | transloco }}</h2>
    <p>{{ 'marketplace.search.empty-state.content' | transloco }}</p>
    <a class="button" [routerLink]="['/']">
      {{'marketplace.search.empty-state.cta' | transloco}}
    </a>
  </div>
}
